const CalibrationPointTypeEnum = Object.freeze({
    PIXEL_X: 'PIXEL_X',
    PIXEL_Y: 'PIXEL_Y',
    COORDINATE_X: 'COORDINATE_X',
    COORDINATE_Y: 'COORDINATE_Y',
    COORDINATE_Z: 'COORDINATE_Z',
});

export default CalibrationPointTypeEnum;
